<template>
  <div
    v-if="!_.isEmpty(errors)"
    :data-cy="`form-errors`"
    class="alert alert-danger"
  >
    <strong>Whoops!!</strong> There were some problems with your input<br><br>
    <ul>
      <li
        v-for="(error, key) in errors"
        :key="key"
      >
        {{ error[0] }}
      </li>
    </ul>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  props: {
    errors: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    _() {
      return _;
    },
  },
};
</script>
